<template>
	<ModalFormCard :action="action" class="modal-default" :submittedCallback="callback">
		<template #title>{{ user.fullName() }} roles</template>

		<template #default="{ saving, errors }">
            <div class='grid grid-cols-2 gap-4'>
                <InputCheckbox v-for='role in roles' name='roles[]' :value='role' :checked="user.hasRole(role)">
                    <p class='-mt-0.5 text-15 pl-2'>{{ $help.capitalizeFirstLetter(role.split('.')[1]) }}</p>
                </InputCheckbox>
            </div>

			
			<div class="modal-buttons pt-6">
				<ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Update user
				</ButtonSaving>
			</div>
		</template>
	</ModalFormCard>
</template>

<script>
import User from "~/models/user.js";
import Modal from "~/mixins/modal.js";
import InputFile from "~/components/customer/input/file.vue";

export default {
	mixins: [Modal],

	created() {
		this.setup(User, this.editingModel);
        this.action = '/actions/user-update-roles/' + this.editingModel.id;
	},

	data() {
		return {
			roles: [
                'zapo.design',
                'zapo.marketing',
                'zapo.sales',
                'zapo.service',
            ],
			canSeePassword: false
		};
	},

	methods: {
		callback() {
			this.$event.$emit('modal-form-completed')
            this.$event.$emit('modal-close')
		},

		generatePassword() {
			this.value.password = this.$help.generatePassword();
			this.canSeePassword = true;
		},
	},

	computed: {
		user() {
            return this.editingModel;
        }
	},

	components: {
		InputFile,
	},
};
</script>
